import moment from 'moment'
import 'moment-timezone'

export function dateFormatter (date, timezone, format) {
  if (!date) return
  const zone = timezone || 'UTC'
  return moment(date).format(format)
}



// WEBPACK FOOTER //
// ./src/services/date-formatter.js